<template>
	<div>
		<div class="container">
			<div class="box3-view" @click="skaCode">
				<div>选择卡口</div>
				<div class="example-body" style="flex: 1">{{JSON.stringify(checkDoor) != '{}' ? checkDoor.title : ''}}
				</div>
				<img src="@/static/sileiyao/saomiao.png"></img>
			</div>
			<div class="box3-view">
				<div>登记原因</div>
				<div class="example-body" style="flex: 1">
					<radio-group class="radio-group" @change="reasonChange" style=" margin-left: 0;">
						<radio class="ts7" value="发热病人" :checked="reason == '发热病人'" color="#064FF2"><p>发热病人</p>
						</radio>
						<radio class="ts7" value="黄码" :checked="reason == '黄码'" color="#064FF2"><p>黄码</p></radio>
						<radio class="ts7" value="红码" :checked="reason == '红码'" color="#064FF2"><p>红码</p></radio>
					</radio-group>
				</div>
			</div>
			<div class="box3-view">
				<div>真实姓名</div>
				<div class="example-body" style="flex: 1">
					<input placeholder="请输入购药人真实姓名" placeholder-style="color:#C7C7C7" type="text" v-model="gmrname" />
				</div>
			</div>
			<div class="box3-view">
				<div>身份证号</div>
				<div class="example-body" style="flex: 1">
					<input placeholder="请输入购药人身份证号" placeholder-style="color:#C7C7C7" type="text" v-model="gmrsfzh" />
				</div>
			</div>
			<div class="box3-view">
				<div>联系电话</div>
				<div class="example-body" style="flex: 1">
					<input placeholder="请输入购药人电话号码" placeholder-style="color:#C7C7C7" type="text" v-model="phone" />
				</div>
			</div>
			<div class="box3-view">
				<div>体&nbsp;&nbsp;温</div>
				<div class="example-body" style="flex: 1">
					<input placeholder="请输入体温" placeholder-style="color:#C7C7C7" type="text" v-model="tiwen" />
				</div>
				<div style=" padding-right: 30rpx; color:#C7C7C7;">℃</div>
			</div>
			<div class="box3-view">
				<div>居住地址</div>
				<picker :range="regionTypeAry" range-key="name" @change="regionValue">
					<div class="minpicker">{{region? region: '请选择区域' }}</div>
				</picker>
				<picker :range="streetTypeAry" range-key="name" @change="streetValue" v-if="region">
					<div class="minpicker">{{street? street: '请选择街道' }}</div>
				</picker>
				<div class="minpicker" @click="streetNone()" v-else>请选择社区</div>
				<picker :range="communityTypeAry" range-key="name" @change="communityValue" v-if="street">
					<div class="minpicker">{{community? community: '请选择社区' }}</div>
				</picker>
				<div class="minpicker" @click="communityNone()" v-else>请选择社区</div>
			</div>
			<div class="box3-view">
				<div>详细地址</div>
				<div class="example-body" style="flex: 1">
					<input placeholder="请输入详细地址" placeholder-style="color:#C7C7C7" type="text" v-model="address" />
				</div>
			</div>
		</div>
		<div class="submit_div">
			<button form-type="submit" class="submit_btn" @click="add()">提交</button>
		</div>

	</div>
</template>

<script>
	// import imgTools from '@/static/js/imgOper.js'
	// import {getKakouFindById,getCascade,medicineAddtsrq} from "../../static/api/index.js"

	export default {
		onLoad(option) {
			this.getCascade(0, '').then(res => {
			 this.regionTypeAry = res.list
			})
		},
		data() {
			return {
				name: "请扫码获取东楚通用户信息",
				index: -1, // 默认选中
				checkDoor: {},
				regionTypeAry: [], // 区域集合
				region: '',
				streetTypeAry: [], // 街道集合
				street: '',
				communityTypeAry: [], // 社区集合
				community: '',
				userObj: {}, // 代购人姓名、电话(登录用户)
				gmrname: '', // 购药人真实姓名
				gmrsfzh: '', // 购药人身份证号
				phone: '', // 购药人联系电话
				tiwen: '', // 购药人体温
				address: '', // 购药人详细地址
				reason: '发热病人', // 原因
			}
		},
		methods: {
			async getCascade(level, parent) {
				return await getCascade(level, parent);
			},
			// 切换选中-区域
			regionValue(e) {
				let value = this.regionTypeAry[e.target.value].name;
				this.region = value;
				this.street = ''
				this.community = ''
				this.getCascade(1, value).then(res => {
					this.streetTypeAry = res.list
				})
			},
			// 切换选中-街道
			streetValue(e) {
				let value = this.streetTypeAry[e.target.value].name;
				this.street = value;
				this.community = ''
				this.getCascade(4, value).then(res => {
					this.communityTypeAry = res.list
				})
			},
			// 切换选中-社区
			communityValue(e) {
				this.community = this.communityTypeAry[e.target.value].name;
			},
			reasonChange(e) {
				let {
					currentTarget: {
						dataset: {
							key
						}
					},
					detail: {
						value
					}
				} = e;
				this.reason = value;
			},
			streetNone() {
				uni.showToast({
					title: '请先选择区域',
					icon: "none",
					position: "center",
				})
			},
			communityNone() {
				if (!this.region) {
					uni.showToast({
						title: '请先选择区域',
						icon: "none",
						position: "center",
					})
				} else if (!this.street) {
					uni.showToast({
						title: '请先选择街道',
						icon: "none",
						position: "center",
					})
				}
			},
			valid() {
				let msg = '';
				if (this.index == -1) {
					msg = '请先选择您对应的药店卡口';
				}
				if (!this.gmrname) {
					msg = '请输入购药人真实姓名';
				} else {
					if (!(/^[\u4e00-\u9fa5]{2,8}$/.test(this.gmrname.trim()))) {
						msg = '请输入正确的中文名';
					}
				}
				if (!this.gmrsfzh) {
					msg = '请输入购药人身份证号码';
				} else if (!imgTools.isIdcard(this.gmrsfzh)) {
					msg = '请输入正确的身份证号码';
				}
				if (!this.phone) {
					msg = '请输入购药人电话号码';
				}
				if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.phone.trim()))) {
					msg = '请输入正确的手机号';
				}
				if (!this.community) {
					msg = '请选择社区';
				}
				if (!this.street) {
					msg = '请选择街道';
				}
				if (!this.region) {
					msg = '请选择区域';
				}
				if (!this.address) {
					msg = '请填写详细地址';
				}
				if (!this.tiwen) {
					msg = '请填写体温';
				} else if (!(/^([3-4][0-9]*)(\.\d+)?$/.test(this.tiwen))) {
					msg = '请输入正确的体温';
				}
				if (!this.reason) {
					msg = '请选择登记原因';
				}
				return msg;
			},
			add() {
				let msg = this.valid();
				if (msg) {
					uni.showToast({
						title: msg,
						icon: "none",
						position: "center",
					})
				} else {
					// 1.记录缓存数据
					let obj = {}
					obj.door_id = this.checkDoor.id;
					obj.door_title = this.checkDoor.title;
					obj.mobile = this.phone;
					obj.name = this.gmrname;
					obj.sfzh = this.gmrsfzh;
				 obj.tw = this.tiwen;
					obj.reason = this.reason;
					obj.address_area = this.region;
					obj.address_street = this.street;
					obj.address_coummunity = this.community;
					obj.address_info = this.address;
					// 2.提交数据
					uni.showLoading({
						title: '数据提交中...',
						mask: true
					})
					this.submit(obj).then(res => {
						uni.hideLoading()
						// 2.跳转页面
						uni.showToast({
							title: "提交成功",
							icon: "success",
							position: "center",
							success: () => {
								setTimeout(function() {
									uni.switchTab({
										url: "../yaoguan/index"
									})
								}, 1000)
							}
						})
					})
				}
			},
			async submit(obj) {
				return await medicineAddtsrq(obj)
			},
			skaCode() {
				// 微信小程序扫码-卡口
				wx.scanCode({
					onlyFromCamera: false,
					scanType: ['qrCode'],
					success: async (res) => {
						var paraString = res.result;
						var paras = paraString.split("=");
						let parasID = paras[1];
						//let parasID = 12985; //测试数据
						this.getKakouFindCode(parasID).then(res => {
							this.checkDoor = res.obj;
							this.index = 1;
						})
					}
				})
			},
			async getKakouFindCode(parasid) {
				return await getKakouFindById(parasid);
			},
		}
	}
</script>
<style scoped>
	.container {
		position: relative;
		font-size: 16px;
	}

	.status-btn {
		/* #ifndef APP-NVUE */
		display: flex;
		/* #endif */
		flex-direction: row;
		align-items: center;
		justify-content: center;
		height: 46px;
		margin: 15px;
		background-color: #007AFF;
	}

	.example-body {
		/* #ifndef APP-NVUE */
		display: block;
		/* #endif */
		padding: 15px 0;
		flex-direction: row;
	}

	.box2 {
		width: 100%;
		height: 80px;
		background: white;
		display: flex;
		align-items: center;
		box-sizing: border-box;
		padding: 0 20px;
		border-bottom: 1upx solid rgba(238, 238, 238, 1);
	}

	.box2 .userimage {
		width: 50px;
		height: 50px;
		margin-right: 13px;
		border-radius: 100%;
	}

	.box2 .usertext {
		flex: 1;
	}

	.box-view-view {
		padding: 15px 0;
		text-align: right;
	}

	.box-view-view>img {
		width: 25px;
		height: 25px;
	}

	.minpicker {
		font-size: 14px;
	}

	.box3-view-title {
		padding: 10px;
		font-size: 14px;
		color: rgb(153, 153, 153);
		background-color: #f2f2f2;
	}

	.box3-view,
	.box3-view5 {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 96%;
		margin: auto;
		height: 55px;
		border-bottom: 1px solid rgba(238, 238, 238, 1);
	}

	.box3-view>view:nth-of-type(1),
	.isClassified {
		width: 95px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(64, 64, 66, 1);
		text-align: center;
	}

	.box3-view5 {
		justify-content: flex-start;
	}

	.isClassified {
		width: 90px !important;
	}

	.radio-group {
		font-size: 16px;
		margin-left: 10px;
	}

	.radio {
		margin-right: 25px;
	}

	input,
	.picker-view {
		width: 240px;
		box-sizing: border-box;
		padding: 0 10px;
		color: rgba(64, 64, 66, 1);
		font-size: 16px;
	}

	.input {
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #C7C7C7;
	}

	.picker-view {
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(203, 207, 208, 1);
	}

	.picker-view-true {
		width: 240px;
		box-sizing: border-box;
		padding: 0 5px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #404042;
	}

	.box3-view>img {
		width: 20px;
		height: 20px;
		margin-right: 5px;
	}

	.box3-view6 {
		width: 96%;
		padding: 8px 0;
		margin: auto;
		overflow: hidden;
		border-bottom: 1px solid rgba(238, 238, 238, 1);
	}

	.box3-view6 .file_view {
		margin: 15rpx 0 15rpx 30rpx;
		color: #DFDFDF;
		width: 148rpx;
		text-align: center;
		height: 148rpx;
		line-height: 120rpx;
		border: 1rpx solid #DFDFDF;
		font-size: 120rpx;
		float: left;
	}

	.box3-view6-list {
		width: 148rpx;
		height: 148rpx;
		float: left;
		margin: 15rpx 0 15rpx 30rpx;
	}

	.box3-view6-list>img {
		width: 100%;
		height: 100%;
	}

	.submit_div {
		text-align: center;
		margin-top: 80rpx;
	}

	.submit_btn {
		width: 90%;
		height: 100rpx;
		background-color: #4293F4;
		color: #FFFFFF;
		font-size: 36rpx;
		border-radius: 10rpx;
	}

	.footer-Main {
		font-size: 24rpx;
		margin: 40rpx;
		padding: 20rpx;
		color: rgb(153, 153, 153);
		background-color: #f2f2f2;
	}

	.footer-Main-title {
		font-size: 36rpx;
	}

	.footer-Main>view {
		margin: 20rpx;
		color: rgb(153, 153, 153);
	}

	.ts7 {
		transform: scale(0.8);
	}

	.ts7 p {
		font-size: 38.5rpx;
		color: rgba(64, 64, 66, 1);
	}
</style>
